import { observer } from 'mobx-react';
import React from 'react';
import { attachFrontendTrackingIds } from '@udemy/browse-event-tracking';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { useHeaderStore } from '../../hooks/use-header-store';
import { HeaderButton, HeaderDropdown, HeaderMenu } from '../header-dropdown.react-component';
import { ShoppingItems } from './shopping-items.react-component';
const UnwishlistedIcon = props => /*#__PURE__*/React.createElement(Icon, Object.assign({
  glyph: "wishlisted-outline",
  label: false
}, props));
UnwishlistedIcon.$$udType = 'Icon';
export const WishlistDropdown = observer(({
  className
}) => {
  const headerStore = useHeaderStore();
  const {
    gettext
  } = useI18n();
  const [shoppingList, _setShoppingList] = React.useState();
  const setShoppingList = () => {
    const wishlist = headerStore.shoppingClient.lists.wishlist;
    attachFrontendTrackingIds(wishlist.items.map(item => item.buyable));
    _setShoppingList(wishlist);
  };
  const {
    urls
  } = headerStore;
  const cta = {
    text: gettext('Go to wishlist'),
    url: urls.WISHLIST
  };
  const zeroState = {
    text: gettext('Your wishlist is empty.'),
    cta: {
      text: gettext('Explore courses'),
      url: urls.BROWSE
    }
  };
  const scroll = {
    itemCount: 2,
    maxHeight: '50.8rem'
  };
  return /*#__PURE__*/React.createElement(HeaderDropdown, {
    trigger: /*#__PURE__*/React.createElement(HeaderButton, {
      componentClass: "a",
      href: urls.WISHLIST,
      udStyle: "icon",
      "data-purpose": "wishlist-icon"
    }, /*#__PURE__*/React.createElement(UnwishlistedIcon, {
      color: "neutral",
      label: gettext('Wishlist')
    })),
    className: className,
    onFirstOpen: setShoppingList
  }, /*#__PURE__*/React.createElement(HeaderMenu, null, /*#__PURE__*/React.createElement(ShoppingItems, {
    shoppingClient: headerStore.shoppingClient,
    shoppingList: shoppingList,
    cta: cta,
    zeroState: zeroState,
    scroll: scroll,
    showAddToCart: true,
    showTotal: false
  })));
});
//# sourceMappingURL=wishlist-dropdown.react-component.js.map